module.exports = __webpack_public_path__ + "static/media/advantage1.e5c4f668.png";